module.exports = __webpack_public_path__ + "img/crosshair.1c802f70.svg";